import { useNavigate } from "react-router-dom";
import { IconChevronLeft } from "./icons";
import { useMobile } from "../features/maintenance-mobile/mobile-ui";

/**
 * "Voltar" das telas em que se entra a partir de outra. Volta no histórico quando
 * a pessoa veio de uma tela do app; se abriu o endereço direto, vai para `fallback`.
 */
export function BackButton({ fallback, label = "Voltar", onClick }: { fallback: string; label?: string; onClick?: () => void }) {
  const navigate = useNavigate();
  // Na casca mobile o cabeçalho já tem a seta de voltar — um segundo "Voltar" só ocupa a tela.
  // Exceção: `onClick` próprio (ex.: sair de um passo interno), que a seta do cabeçalho não faz.
  const mobile = useMobile();
  if (mobile && !onClick) return null;
  const voltar = () => {
    if (onClick) return onClick();
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button type="button" onClick={voltar} className="inline-flex min-h-[2.75rem] items-center gap-1.5 rounded-lg border border-surface-border bg-white px-4 text-sm font-medium text-gray-700 hover:bg-surface-muted">
      <IconChevronLeft className="h-4 w-4" /> {label}
    </button>
  );
}
